import { moveToFulfilled, remove } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { SuggestedLeadersDismissFulfilledAction } from '../../domains/suggestedLeaderDismiss/actions.types';
import {
  SuggestedLeadersLoadAction,
  SuggestedLeadersLoadMoreAction,
} from '../../domains/suggestedLeaders/actions.types';

import { SuggestedLeaders } from './types';
export const initialState: SuggestedLeaders = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

export type SuggestedLeadersAction =
  | SuggestedLeadersLoadAction
  | SuggestedLeadersLoadMoreAction
  | SuggestedLeadersDismissFulfilledAction;

const reducer: Reducer<SuggestedLeaders, SuggestedLeadersAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'SUGGESTED_LEADERS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.suggestedLeaders);
    case 'SUGGESTED_LEADERS.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.suggestedLeaders);
    case 'SUGGESTED_LEADERS.DISMISS_FULFILLED':
      return remove(state, [action.payload.userId]);
    default:
      return state;
  }
};

export default reducer;
